import { env } from 'next-runtime-env';

/**
 * Local-only same-origin BFF proxy.
 *
 * Auth-v1 sets HttpOnly cookies with SameSite=Strict (see mindoasis-backend
 * cookie.config). Those cookies are not sent on cross-site fetches from
 * http://localhost → api.*.mindoasis.com. Proxying through this app origin
 * makes the cookies first-party so local sign-in works without backend changes.
 */
export const BFF_LOCAL_PROXY_PATH_PREFIX = '/api/bff-proxy';

export function isBffLocalProxyEnabled(): boolean {
  return (
    env('NEXT_PUBLIC_BFF_LOCAL_PROXY') === 'true' ||
    process.env.NEXT_PUBLIC_BFF_LOCAL_PROXY === 'true'
  );
}

/** Absolute upstream API origin (never the proxy path). */
export function getBffProxyTargetOrigin(): string {
  const fromEnv =
    process.env.BFF_PROXY_TARGET ||
    env('NEXT_PUBLIC_BACKEND_API_URL') ||
    process.env.NEXT_PUBLIC_BACKEND_API_URL ||
    '';
  return fromEnv.replace(/\/$/, '');
}

/**
 * Browser / same-tab base URL for BFF when the local proxy is on.
 * Relative on the client; absolute loopback on the server (Node fetch).
 */
export function getBffLocalProxyBaseUrl(): string {
  if (typeof window !== 'undefined') {
    return BFF_LOCAL_PROXY_PATH_PREFIX;
  }

  const port = process.env.PORT || '3000';
  return `http://127.0.0.1:${port}${BFF_LOCAL_PROXY_PATH_PREFIX}`;
}
